module.exports = __webpack_public_path__ + "img/progress.2b4fafc0.gif";